<template>
	<div>

		<vcl-table :rows="3" :columns="4" v-if="!loadedProfile"></vcl-table>

		<div v-if="loadedProfile">

			<div class="tip" v-if="isCompleted && userPeople && userPeople.cat_people_status_id != 3" >
				<p style="text-align: center;">
					El perfil está completo, nos encontramos validando su información, le enviaremos un correo electrónico
					con el estatus de su registro.
				</p>


			</div>


			<div class="tip" v-if="isCompleted && checkLetter() == true" >
				<el-row :gutter="20">
					<el-col align="center" :span="24" :offset="0"
					        v-if="form.a_fellow && form.a_fellow.person && form.a_fellow.person.hash_id">
						<a style="text-decoration: none;color: #6c798c;"
						   class="el-button el-button--default" @click="downloadCard(form.a_fellow.person.hash_id)">
							Descargar carta compromiso
						</a>
						<a style="text-decoration: none;color: #6c798c;"
						   class="el-button el-button--default" @click="downloadNotice(form.a_fellow.person.hash_id)">
							Descargar aviso de privacidad
						</a>
					</el-col>
				</el-row>
				<br/>

					<el-row :gutter="20">
						<el-col align="center" :span="10" :offset="7" >
							Descargar carta compromiso, firmarla, escanearla y subir el archivo aquí
							<br/><br/>
							<upload-document
									buttonName="Subir carta compromiso"
									@fileInfo="addFileCommitmenLetter"/>
						</el-col>
					</el-row>
			</div>
			<FormCompleteProfile v-if="!isCompleted"/>

		</div>
		<!-- vinculacion --->

	
		<RelationShipYoungWithAdvisor/>
	


	</div>
</template>

<script>


	import {completeProfileMix} from '@/mixins/young/completeProfile';
	import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';


	export default {
		mixins: [completeProfileMix],
		computed: {
			...mapGetters(["userFullName", "cat_profile_id", "userEmail","user_hash" ,"userInfo", "userPeople"])
		},
		mounted() {
			this.iniOnlyProfile();
		},
		methods:{
			downloadCard (idHash) {
      axios.post('/pdf2',{'hash_id':idHash}, {responseType: 'blob'}).then(function (response) {
        const linkUrl = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = linkUrl
        // TODO: setrealname for workplan
        link.setAttribute('download', 'Carta compromiso.pdf')
        document.body.appendChild(link)
        link.click()
      })
        .catch(error=> {
          console.log(error)
          this.$message({
              			type: "warning",
              			title: "Advertencia",
              			message: "Ocurrio un error al intentar descargar la carta compromiso, intentelo nuevamente o consulte al administrador"
            		});
        })
    },
	downloadNotice (idHash) {
      axios.post('/pdf3',{'hash_id':idHash}, {responseType: 'blob'}).then(function (response) {
        const linkUrl = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = linkUrl
        // TODO: setrealname for workplan
        link.setAttribute('download', 'Aviso de privacidad.pdf')
        document.body.appendChild(link)
        link.click()
      })
        .catch(error=> {
          console.log(error)
          this.$message({
              			type: "warning",
              			title: "Advertencia",
              			message: "Ocurrio un error al intentar descargar la carta compromiso, intentelo nuevamente o consulte al administrador"
            		});
        })
    },
		},
		watch: {
			$route: 'iniOnlyProfile'
		},

	};
</script>

<style scoped>

</style>